var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-5"
};
import { canSeeFeature, isNetworkAdmin, sessionState } from "@/core/session";
import { apiTasks } from "./api";
import TaskSection from "./TaskSection.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MyTasksListingPanel',
    setup(__props) {
        const loadMyTasks = () => __awaiter(this, void 0, void 0, function* () {
            const tasks = yield apiTasks.getMyAssignedTasks();
            // Since we've just loaded these, may as well update the global cache
            sessionState.myAssignedTasks = tasks;
            return tasks;
        });
        return (_ctx, _cache) => {
            return (_unref(canSeeFeature)('tasks'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(TaskSection, {
                        title: "My Tasks",
                        subtitle: "View All Of Your Tasks In One Place",
                        getTasks: loadMyTasks,
                        showEntityLink: "",
                        allowShowAll: _unref(isNetworkAdmin)()
                    }, null, 8, ["allowShowAll"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
